<template>
  <BuildingPage title="导出记录" description="导出记录页预留任务状态、下载结果和失败重试等能力，等待导出接口接入。" />
</template>

<script>
import BuildingPage from '@/views/report/building/building.vue'

export default {
  name: 'ReportExportPage',
  components: {
    BuildingPage
  }
}
</script>
